// ContactUs.js
import React from 'react';
import './Pages.css';

function ContactUs() {
  return (
    <section id="contactus" className='has-fixed-header py-5 pb-0'>
    <div className='container-fluid p-0 ps-0'>
    <div className="container">
      {/* Hero Section */}
      <div className="row align-items-center mb-4">
        <div className="col text-center">
          <h1 className="display-6 text-primary">Contact Us</h1>
          <p className="col-md-8 col-sm-12 mx-auto lead text-black">
            We’d love to hear from you! Reach out to us with your questions, feedback, or inquiries, and our team will get back to you as soon as possible.
          </p>
        </div>
      </div>

      <div className="row g-5 pb-5">
        {/* Contact Form */}
        <div className="col-md-6 col-sm-12">
          <h4 className="text-black mb-4 col-title border-bottom">Send Us a Message</h4>
          <form className='mt-4'>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter your name"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="subject" className="form-label">
                Subject
              </label>
              <input
                type="text"
                className="form-control"
                id="subject"
                placeholder="Enter the subject"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">
                Message
              </label>
              <textarea
                className="form-control"
                id="message"
                rows="5"
                placeholder="Write your message here"
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary rounded-pill px-4">
              Submit
            </button>
          </form>
        </div>

        {/* Location and Address */}
        <div className="col-md-6 col-sm-12">
          <h4 className="text-black mb-4 col-title border-bottom">Our Location</h4>
          <p className="text-muted mt-4">
            Feel free to visit us or get in touch with us at the address below:
          </p>
          <div className="mb-3">
            <h5 className="fw-bold">Address</h5>
            <p className="text-muted">
              123 Elevate Avenue, Suite 456<br />
              HealthTech City, HT 78910<br />
              United States
            </p>
          </div>
          <div className="mb-3">
            <h5 className="fw-bold">Phone</h5>
            <p className="text-muted">+1 (123) 456-7890</p>
          </div>
          <div className="mb-3">
            <h5 className="fw-bold">Email</h5>
            <p className="text-muted">contact@elevate.com</p>
          </div>

          {/* Embedded Google Map */}
          <div className="mt-4">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.8354345093646!2d-122.40135168468183!3d37.78814957975779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858064df1efcd3%3A0xfbf3ea49dcf8a8b1!2sHealthTech%20Center!5e0!3m2!1sen!2sus!4v1615262835311!5m2!1sen!2sus"
              width="100%"
              height="300"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>


      




      



  </div>



    </section>
  );
}

export default ContactUs;